import { PanelUsage } from '../Panel/PanelUsage';
import { jsx as _jsx } from "react/jsx-runtime";
export const PanelUsageEnrichment = ({
  numberOfOperations
}) => /*#__PURE__*/_jsx(PanelUsage, {
  action: "DATASET_ENRICHMENT",
  numberOfOperations: numberOfOperations
});